const CashOnDelivery = () => {
    return (
        <div>
            <div className="flex flex-col justify-center items-center">
            <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
            <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
                
                <div className="flex flex-col justify-center">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        COD & COD+
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        Always looking for ways to add more value for its customers, TCS E-com division started offering 
                        Cash-on-Delivery services in 2006. Witnessing the enormous advantages for home/small and medium 
                        enterprises, almost all retail corporations now leverage the benefits that COD provides.
                    </p>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        Going a step further, TCS started COD+ in 2022, allowing home/small businesses as well as the 
                        cottage industries to use the strengths of COD. Suitable for low volume or infrequent deliveries, 
                        COD+ provides the facility of quick cash reimbursements, without having the need of opening a 
                        corporate account or a bank account at all.
                    </p>
                    
                </div>
                <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
                    <img src="/ecom-solution/cod.jpg" alt="" className="rounded-md max-w-[100%]"/>
                </div>
                </div>
            
            </div>
        </div>
    )
};
export default CashOnDelivery;